var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Program = YouLi.Trip.Program ? YouLi.Trip.Program : {};

(function (YouLi) {
    (function (Trip) {
        (function (Program) {

            var scrollerAdvanceAmount = 120;

            YouLi.Trip.Program.ProgramItems = null;
            YouLi.Trip.Program.ItemHeight = 530;
            YouLi.Trip.Program.ProgramSelectedDate = "";
            YouLi.Trip.Program.ProgramFilteredIds = [];
            YouLi.Trip.Program.SaveDone = false;
            YouLi.Trip.Program.TargetElementForResponse = undefined;

            YouLi.Trip.Program.GoToDate = function (selectedDate) {
                YouLi.Trip.Program.ProgramSelectedDate = selectedDate;
                YouLi.Trip.Program.FilterItems();
            }

            YouLi.Trip.Program.FilterItems = function () {

                // Update the activated menu
                $("#content-trip-program .trip-dates-menu .nav li").removeClass("active");

                var element = $("#content-trip-program .trip-dates-menu .nav").find("li[data-date='" + YouLi.Trip.Program.ProgramSelectedDate + "']");
                element.addClass("active");

                // find the IDs to show and hide
                var itemsToShow = $.grep(YouLi.Trip.Program.ProgramItems, function (n, i) {
                    var startDateTime = moment(n.StartDateTime);
                    var endDateTime = moment(n.EndDateTime);
                    var selectedDateMoment = moment(YouLi.Trip.Program.ProgramSelectedDate);

                    if (n.EndDateTime === null)
                        return startDateTime.isSame(selectedDateMoment, 'date');

                    return selectedDateMoment.isBetween(startDateTime, endDateTime, 'date', '[]');
                });

                YouLi.Trip.Program.ProgramFilteredIds = $.map(itemsToShow, function (n, i) {
                    return n.ScheduleItemId;
                });

                $programGrid.isotope({
                    filter: function () {
                        // _this_ is the item element. Get text of element's .number
                        if (YouLi.Trip.Program.ProgramSelectedDate === "all")
                            return true;
                        // return true to show, false to hide
                        return YouLi.Trip.Program.ProgramFilteredIds.indexOf($(this).find(".program-item-contents").attr('data-id')) > -1;
                    }
                });
            }

            YouLi.Trip.Program.UpdateMenuNav = function () {

                if (YouLi.Trip.StyleName) {
                    return 0;
                }

                if ($("#content-trip-program .trip-dates-menu").length > 0) {
                    if (YouLi.Trip.CurrentSection == "program") {
                        var scrollerNavLeft = $("#content-trip-program .scroller-nav").position().left;
                        var currentLeft = $("#content-trip-program .trip-dates-menu li").position().left;
                        var lastItem = $("#content-trip-program .trip-dates-menu li:last-child");
                        var lastItemRight = lastItem.position().left + lastItem.outerWidth();

                        $("#content-trip-program .scroller-nav .left").toggleClass("disabled", currentLeft >= 0);
                        $("#content-trip-program .scroller-nav .right").toggleClass("disabled", lastItemRight < scrollerNavLeft);

                        // Fix the max width of program menu
                        $("#content-trip-program .trip-dates-menu").css("max-width", "0px");
                        var containerWidth = $(".content-trip-details-main").width();
                        $("#content-trip-program .trip-dates-menu").css("max-width", containerWidth + "px");
                    }
                }
            }

            YouLi.Trip.Program.RefreshLayout = function () {
                if (YouLi.Trip.StyleName) {
                    return;
                }
                // Reset height of all items first
                if ($(window).width() > 767) {
                    $(".program-item").height(YouLi.Trip.Program.ItemHeight).css("max-height", YouLi.Trip.Program.ItemHeight);
                }
                else {
                    $(".program-item").height("auto").css("max-height", YouLi.Trip.Program.ItemHeight)
                }

                $cachedWindowWidth = $(window).width();

                RefreshItemExpandVisibility();

                if ($programGrid.data('isotope')) {
                    $programGrid.isotope('layout');
                }

            }

            RefreshItemExpandVisibility = function (element) {
                $(".program-item").each(function (element) {
                    // update the visibility of the show more for this item
                    $(this).find(".show-more").toggle($(this).height() < $(this).find(".program-item-contents").height());
                });
            }

            ShowItemDetails = function (gridItemElement) {
                $(gridItemElement).find(".program-item-contents").clone().appendTo($("#ProgramItemDialog .modal-body").empty()).find(".show-more").remove();
                $currentlySelectedItem = $(gridItemElement);

                // (re-)init optional checkbox in popup
                $("#ProgramItemDialog .multistate-check-schedule-item-response").multiStateCheck({
                    states: ["unchecked", "checked"],
                    onAfterChangeState: function (e) {

                        const applyToGang = true;
                        YouLi.Trip.Schedule.Response.MultiStateCheckUpdateAndTakeAction(e.target, applyToGang, function () {

                            if ($("#PreviewMode").val() != "True") {
                                // update the grid version of this item's checkbox, too
                                // update any other response checkboxes for the item (ie., if there are any showing in 
                                $(".grid .program-item-contents[data-id=" + programItemId + "] .multistate-check-schedule-item-response").attr("data-state", $(e.target).attr("data-state"));
                            }

                        });
                    }
                });
            }

            $(document).on("shown.bs.modal", "#ResponseDialogYes", function (e) {
                YouLi.Trip.Program.SaveDone = false;
            });

            $(document).on('hidden.bs.modal', "#ResponseDialogYes", function (e) {
                if (!YouLi.Trip.Program.SaveDone && YouLi.Trip.Program.TargetElementForResponse) {
                    // reset the multistate check to the previous value
                    $(YouLi.Trip.Program.TargetElementForResponse).data("multiStateCheck").revert();
                    YouLi.Trip.Program.TargetElementForResponse = undefined;
                }
            });

            var $programGrid = null;
            var $cachedWindowWidth = null;
            var $currentlySelectedItem = null;

            var ProgramItemDialogGoToNext = function () {
                var $nextItem = $currentlySelectedItem.first().next();
                if ($nextItem.length == 0) {
                    $nextItem = $(".grid .grid-item").first();
                }
                ShowItemDetails($nextItem);
            };

            var ProgramItemDialogGoToPrev = function () {
                var $prevItem = $currentlySelectedItem.first().prev();
                if ($prevItem.length == 0) {
                    $prevItem = $(".grid .grid-item").last();
                }
                ShowItemDetails($prevItem);
            };

            $(function () {

                RefreshItemExpandVisibility();

                $cachedWindowWidth = $(window).width();

                $('.action-done-popover').popover({
                    trigger: "manual",
                    template: '<div class="popover notification" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                });

                $(".open-full-link").on("click", function () {
                    if ($(window).width() < 767) {
                        $(this).closest(".program-item").height("auto").css("max-height", "unset");
                        $(this).closest(".program-item").find(".show-more").hide();
                        $programGrid.isotope('layout');
                    }
                    else {
                        ShowItemDetails($(this).closest(".grid-item"));

                        $("#ProgramItemDialog").modal("show");
                    }
                });

                $(document).on("click", "#ProgramItemDialog .next", function () {
                    ProgramItemDialogGoToNext();
                });

                $(document).on("click", "#ProgramItemDialog .prev", function () {
                    ProgramItemDialogGoToPrev();
                });

                $(document).on("keydown", function (e) {
                    if ($("#ProgramItemDialog").is(":visible")) {
                        if (e.keyCode == 37) {
                            ProgramItemDialogGoToPrev();
                        }
                        else if (e.keyCode == 39) {
                            ProgramItemDialogGoToNext();
                        }
                    }
                });

                if (YouLi.Trip.StyleName === "") {
                    $programGrid = $('.grid').imagesLoaded(function () {
                        $programGrid.isotope({
                            itemSelector: '.grid-item',
                            percentPosition: true,
                            masonry: {
                                // use element for option
                                //columnWidth: '.grid-sizer'
                            }
                        });
                    });
                }

                $(document).on('click', '.program-item-date', function () {
                    YouLi.Trip.Program.ProgramSelectedDate = $(this).data("date");
                    YouLi.Trip.Program.FilterItems();
                });

                $(document).on('click', '#content-trip-program .trip-dates-menu .nav li', function () {
                    YouLi.Trip.Program.ProgramSelectedDate = $(this).data("date");
                    YouLi.Trip.Program.FilterItems();
                });

                $(document).on("click", "#content-trip-program .scroller-nav .right:not(.disabled)", function () {
                    var lastItem = $("#content-trip-program .trip-dates-menu li:last-child");
                    var lastItemRight = lastItem.position().left + lastItem.outerWidth();
                    var currentLeft = $("#content-trip-program .trip-dates-menu li").position().left;

                    var newLeft = currentLeft;
                    if (lastItemRight >= $("#content-trip-program .scroller-nav").position().left) {
                        newLeft = Math.min(newLeft - scrollerAdvanceAmount, 0);
                        $("#content-trip-program .trip-dates-menu li").css("left", newLeft);
                    }

                    YouLi.Trip.Program.UpdateMenuNav();

                });
                $(document).on("click", "#content-trip-program .scroller-nav .left:not(.disabled)", function () {
                    var currentLeft = $("#content-trip-program .trip-dates-menu li").position().left;
                    var newLeft = currentLeft;
                    if (currentLeft < 0) {
                        newLeft = Math.min(newLeft + scrollerAdvanceAmount, 0);
                        $("#content-trip-program .trip-dates-menu li").css("left", newLeft);
                    }

                    YouLi.Trip.Program.UpdateMenuNav();

                });

                $(window).resize(function () {
                    YouLi.Trip.Program.UpdateMenuNav();

                    if ($cachedWindowWidth != $(window).width()) {
                        YouLi.Trip.Program.RefreshLayout();
                    }
                });
                YouLi.Trip.Program.RefreshLayout();

                $(document).on("click", "#content-trip-program .invitees-avatars-list", function () {

                    // only allow this if the All Invitees tab is visible to this invitee
                    if (YouLi.Trip.ShowInviteesAllTab) {

                        YouLi.Common.UI.ShowLoading();

                        let itemElement = $(this).closest(".program-item-contents");
                        let programItemId = $(itemElement).data("id");
                        let inviteeId = $("#InviteeId").val();

                        $.ajax({
                            url: `/trip/itineraryparticipants/?id=${programItemId}&inviteeid=${inviteeId}`,
                            type: "GET",
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            complete: function (response) {
                                YouLi.Common.UI.HideLoading();
                                if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                                    YouLi.Common.UI.ShowStandardDialog("An error occurred when loading.");
                                }
                                else {
                                    $("#invitees-dialog-content").html(response.responseText);
                                    $('#invitees-dialog').modal('show');
                                }
                            }
                        });
                    }
                });
            });

        }(YouLi.Trip.Program ? YouLi.Trip.Program : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));
